const vPoster = {
	install(Vue, options = {}) {
		// console.log("install vposter");
	},
};

export default vPoster;
